<template>
  <div>
    <div v-show="isLoading">
      <spin-loader />
    </div>
    <div v-show="!isLoading">
      <b-row>
        <b-col
          cols="12"
          md="12"
          lg="12"
        >
          <assistance-filter
            :visible-columns="tableColumns"
            @filter-change="updateFilter"
            @columns-change="updateColumns"
            @ready="syncLoad.ready('filter')"
          />
        </b-col>
      </b-row>
      <b-row
        class="justify-content-center mt-1"
      >
        <b-col
          cols="12"
          md="12"
          lg="12"
        >
          <assistance-table
            ref="refAssistanceTable"
            :filter="filter"
            :active="true"
            @ready="syncLoad.ready('table')"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'

import AssistanceFilter from './AssistanceFilter.vue'
import SpinLoader from '@/components/spinloader/SpinLoader.vue'
import SyncLoad from '@/components/utils/syncLoad'
import AssistanceTable from './AssistanceTable.vue'

export default {
  components: {
    BRow,
    BCol,
    AssistanceTable,
    AssistanceFilter,
    SpinLoader,
  },
  data() {
    const filter = {
      page_size: 10,
      search: '',
    }

    const isLoading = true
    const syncLoad = new SyncLoad()
    syncLoad.addTrigger('table')

    syncLoad.onReady(() => {
      this.isLoading = false
    })

    const tableColumns = [
      {
        key: 'id',
        label: 'Id',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'order__contract__bidding__client__name',
        label: 'Órgão',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'product__name',
        label: 'Produto',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'type__name',
        label: 'Tipo de Serviço',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'technician_name',
        label: 'Técnico',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'date_scheduled',
        label: 'Data programada',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'status__name',
        label: 'Status',
        visible: true,
        fixedColumn: false,
      },
    ]

    return {
      filter,
      isLoading,
      syncLoad,
      tableColumns,
    }
  },
  methods: {
    updateFilter(val) {
      this.filter = val
    },
    updateColumns(val) {
      this.$refs.refAssistanceTable.refreshColumns(val)
    },
  },
  setup() {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
</style>
